import { defineMessages } from 'react-intl';
import { fromJS } from 'immutable';

const shippingMessages = defineMessages({
    free: {
        id: 'shipping.shippingMessages.free',
        description: 'Used when the shipping method cost is $00.00',
        defaultMessage: 'FREE'
    },
    noneSelected: {
        id: 'shipping.shippingMessages.noneSelected',
        description: 'Used when there is no selection in the shipping method drop down',
        defaultMessage: 'None Selected'
    }
});

const methodDisplayUSPS = defineMessages({
    GROUND: {
        id: 'shipping.shippingMessages.usps.GROUND',
        description: 'Display name for shipping method USPS GROUND',
        defaultMessage: 'USPS Ground'
    },
    'First Class': {
        id: 'shipping.shippingMessages.usps.First Class',
        description: 'Display name for shipping method USPS First Class',
        defaultMessage: 'USPS First Class'
    },
    CANADIAN_POST: {
        id: 'shipping.shippingMessages.usps.CANADIAN_POST',
        description: 'Display name for shipping method USPS Canadian Post',
        defaultMessage: 'Canadian Post'
    },
    'Regular Mail': {
        id: 'shipping.shippingMessages.Regular Mail',
        description: 'Display name for shipping method USPS Regular Mail',
        defaultMessage: 'USPS Mail'
    },
    FEDEX_EXPRESS_SAVER: {
        id: 'shipping.shippingMessages.usps.FEDEX_EXPRESS_SAVER',
        description: 'Display name for shipping method USPS FEDEX_EXPRESS_SAVER',
        defaultMessage: 'USPS Ground'
    },
    Priority: {
        id: 'shipping.shippingMessages.usps.Priority',
        description: 'Display name for shipping method USPS Priority',
        defaultMessage: 'USPS Priority Mail'
    },
    PriorityMail: {
        id: 'shipping.shippingMessages.usps.PriorityMail',
        description: 'Display name for shipping method USPS PriorityMail',
        defaultMessage: 'USPS Priority (Standard)'
    },
    RegularMail: {
        id: 'shipping.shippingMessages.usps.Regular Mail',
        description: 'Display name for shipping method USPS Regular Mail',
        defaultMessage: 'USPS Ground'
    },
    usps1stclass: {
        id: 'shipping.shippingMessages.usps.usps1stclass',
        description: 'Display name for shipping method USPS usps1stclass',
        defaultMessage: 'USPS First Class'
    },
    uspspriority: {
        id: 'shipping.shippingMessages.usps.uspspriority',
        description: 'Display name for shipping method USPS uspspriority',
        defaultMessage: 'USPS Priority Mail'
    }
});

const methodDisplayFedexFixed = defineMessages({
    FEDEX_EXPRESS_SAVER: {
        id: 'shipping.shippingMessages.fedexfixed.FEDEX_EXPRESS_SAVER',
        description: 'Display method FEDEX_FIXED FEDEX_EXPRESS_SAVER',
        defaultMessage: 'FedEx Express Saver 3 Day'
    },
    INTERNATIONAL_ECONOMY: {
        id: 'shipping.shippingMessages.fedexfixed.INTERNATIONAL_ECONOMY',
        description: 'Display method FEDEX_FIXED  INTERNATIONAL_ECONOMY',
        defaultMessage: 'FedEx International Economy'
    },
    INTERNATIONAL_PRIORITY: {
        id: 'shipping.shippingMessages.fedexfixed.INTERNATIONAL_PRIORITY',
        description: 'Display method FEDEX_FIXED  INTERNATIONAL_PRIORITY',
        defaultMessage: 'FedEx International Priority'
    },
    FEDEX_2_DAY: {
        id: 'shipping.shippingMessages.fedexfixed.FEDEX_2_DAY',
        description: 'Display method FEDEX_FIXED  FEDEX_2_DAY',
        defaultMessage: 'FedEx 2 Day'
    },
    PRIORITY_OVERNIGHT: {
        id: 'shipping.shippingMessages.fedexfixed.PRIORITY_OVERNIGHT',
        description: 'Display method FEDEX_FIXED  PRIORITY_OVERNIGHT',
        defaultMessage: 'FedEx Priority Overnight'
    },
    STANDARD_OVERNIGHT: {
        id: 'shipping.shippingMessages.fedexfixed.STANDARD_OVERNIGHT',
        description: 'Display method FEDEX_FIXED  STANDARD_OVERNIGHT',
        defaultMessage: 'FedEx Overnight'
    }
});

const methodDisplayFedex = defineMessages({
    FEDEX_EXPRESS_SAVER: {
        id: 'shipping.shippingMessages.fedex.FEDEX_EXPRESS_SAVER',
        description: 'Display method FEDEX FEDEX_EXPRESS_SAVER',
        defaultMessage: 'FedEx Express Saver 3 Day'
    },
    INTERNATIONAL_ECONOMY: {
        id: 'shipping.shippingMessages.fedex.INTERNATIONAL_ECONOMY',
        description: 'Display method FEDEX INTERNATIONAL_ECONOMY',
        defaultMessage: 'FedEx International Economy'
    },
    INTERNATIONAL_GROUND: {
        id: 'shipping.shippingMessages.fedex.INTERNATIONAL_GROUND',
        description: 'Display method FEDEX INTERNATIONAL_GROUND',
        defaultMessage: 'FedEx International Ground'
    },
    INTERNATIONAL_PRIORITY: {
        id: 'shipping.shippingMessages.fedex.INTERNATIONAL_PRIORITY',
        description: 'Display method FEDEX INTERNATIONAL_PRIORITY',
        defaultMessage: 'FedEx International Priority'
    },
    FEDEX_2_DAY: {
        id: 'shipping.shippingMessages.fedex.FEDEX_2_DAY',
        description: 'Display method FEDEX FEDEX_2_DAY',
        defaultMessage: 'FedEx 2 Day'
    },
    PRIORITY_OVERNIGHT: {
        id: 'shipping.shippingMessages.fedex.PRIORITY_OVERNIGHT',
        description: 'Display method FEDEX PRIORITY_OVERNIGHT',
        defaultMessage: 'FedEx Priority Overnight'
    },
    STANDARD_OVERNIGHT: {
        id: 'shipping.shippingMessages.fedex.STANDARD_OVERNIGHT',
        description: 'Display method FEDEX STANDARD_OVERNIGHT',
        defaultMessage: 'FedEx Standard Overnight'
    },
    FIRST_OVERNIGHT: {
        id: 'shipping.shippingMessages.fedex.FIRST_OVERNIGHT',
        description: 'Display method FEDEX FIRST_OVERNIGHT',
        defaultMessage: 'FedEx First Overnight'
    },
    '3_DAY': {
        id: 'shipping.shippingMessages.fedex.3_DAY',
        description: 'Display method FEDEX 3_DAY',
        defaultMessage: 'FedEx 3 Day'
    },
    '2_DAY': {
        id: 'shipping.shippingMessages.fedex.2_DAY',
        description: 'Display method FEDEX 2_DAY',
        defaultMessage: 'FedEx 2 Day'
    },
    FEDEX_GROUND: {
        id: 'shipping.shippingMessages.fedex.FEDEX_GROUND',
        description: 'Display method FEDEX FEDEX_GROUND',
        defaultMessage: 'FedEx Ground'
    },
    fedexon: {
        id: 'shipping.shippingMessages.fedex.fedexon',
        description: 'Display method FEDEX fedexon',
        defaultMessage: 'FedEx Overnight'
    }
});

const methodDisplayDHL = defineMessages({
    'Standard Expedited': {
        id: 'shipping.shippingMessages.dhl.Standard Expedited',
        description: 'Display method DHL Standard Expedited',
        defaultMessage: 'DHL Standard Expedited'
    },
    GROUND: {
        id: 'shipping.shippingMessages.dhl.GROUND',
        description: 'Display method DHL Ground',
        defaultMessage: 'DHL Ground'
    }
});

const methodDisplayUKPostOffice = defineMessages({
    'First Class Recorded': {
        id: 'shipping.shippingMessages.ukpo.First Class Recorded',
        description: 'Display name for First Class Recorded',
        defaultMessage: 'Post & Packing (UK Only)'
    },
    UKRM: {
        id: 'shipping.shippingMessages.ukpo.UKRM',
        description: 'Display name for UKRM',
        defaultMessage: 'UKRM Standard 1st Class Royal Mail'
    }
});

const methodDisplayRoyalMail = defineMessages({
    '1ST_CLASS_LARGE_SIG': {
        id: 'shipping.shippingMessages.royal.1ST_CLASS_LARGE_SIG',
        description: 'Display method ROYAL_MAIL 1ST_CLASS_LARGE_SIG',
        defaultMessage: 'Royal Mail 1st Class Guaranteed'
    },
    ROYALMAIL_INTERNATIONAL_TS: {
        id: 'shipping.shippingMessages.royal.ROYALMAIL_INTERNATIONAL_TS',
        description: 'Display method ROYAL_MAIL ',
        defaultMessage: 'Royal Mail International Track & Signed'
    },
    '1ST_CLASS_LARGE': {
        id: 'shipping.shippingMessages.royal.1ST_CLASS_LARGE',
        description: 'Display method 1ST_CLASS_LARGE ',
        defaultMessage: 'Royal Mail 1st Class Large Letter'
    },
    '1ST_CLASS_STD': {
        id: 'shipping.shippingMessages.royal.1ST_CLASS_STD',
        description: 'Display method 1ST_CLASS_STD ',
        defaultMessage: 'Royal Mail 1st Class Standard Letter'
    },
    shippingRules: {
        id: 'shippingMethod.messages.shippingRules.md',
        description: 'Describes the shipping rules, supports Markdown',
        defaultMessage: 'Please allow 1-2 business days for order processing.\n\n\u200b\n\n'
            + 'Please note: Multiple cards shipped via USPS will be shipped one per envelope.\n\n\u200b\n\n'
            + 'Items sent to P.O. Boxes, US territories, or military APO/FPO addresses can only be shipped via USPS.'
    }
});

const methodDisplayCanadianPost = defineMessages({
    'Regular Mail': {
        id: 'shipping.shippingMessages.cadpost.Regular Mail',
        description: 'Display method CANADAPOST Regular Mail',
        defaultMessage: 'Canada Post'
    },
    '2nd Day': {
        id: 'shipping.shippingMessages.cadpost.2nd Day',
        description: 'Display method CANADAPOST 2nd Day',
        defaultMessage: 'Canada Xpresspost'
    },
    CANADIAN_POST: {
        id: 'shipping.shippingMessages.cadpost.CANADIAN_POST',
        description: 'Display method CANADAPOST CANADIAN_POST',
        defaultMessage: 'Canada Post First Class'
    },
    PRIORITY_OVERNIGHT: {
        id: 'shipping.shippingMessages.cadpost.PRIORITY_OVERNIGHT',
        description: 'Display method CANADAPOST PRIORITY_OVERNIGHT',
        defaultMessage: 'Canada Priority'
    },
    'First Class': {
        id: 'shipping.shippingMessages.cadpost.First Class',
        description: 'Display method CANADAPOST First Class',
        defaultMessage: 'Canada USPS transferred to Canadian Postal'
    }
});

const methodDisplayUPS = defineMessages({
    'Next Day': {
        id: 'shipping.shippingMessages.ups.Next Day',
        description: 'Display method UPS Next Day',
        defaultMessage: 'UPS Next Day Air'
    },
    NextDaySaver: {
        id: 'shipping.shippingMessages.ups.NextDaySaver',
        description: 'Display method UPS NextDaySaver',
        defaultMessage: 'UPS Next Day Saver'
    },
    upsnextday: {
        id: 'shipping.shippingMessages.ups.upsnextday',
        description: 'Display method UPS upsnextday',
        defaultMessage: 'UPS Next Day'
    },
    '2 Day': {
        id: 'shipping.shippingMessages.ups.2 Day',
        description: 'Display method UPS 2 Day',
        defaultMessage: 'UPS 2 Day'
    },
    '3Day': {
        id: 'shipping.shippingMessages.ups.3Day',
        description: 'Display method UPS 3 Day',
        defaultMessage: 'UPS 3 Day'
    },
    '2nd Day': {
        id: 'shipping.shippingMessages.ups.2nd Day',
        description: 'Display method UPS 2nd Day',
        defaultMessage: 'UPS 2nd Day Air'
    },
    ups2ndday: {
        id: 'shipping.shippingMessages.ups.ups2ndday',
        description: 'Display method ups2ndday',
        defaultMessage: 'UPS 2-4 Business Days'
    },
    'UPS Standard Overnight': {
        id: 'shipping.shippingMessages.ups.UPS Standard Overnight',
        description: 'Display method UPS UPS Standard Overnight',
        defaultMessage: 'UPS Next Day Saver'
    },
    'UPS Priority Overnight': {
        id: 'shipping.shippingMessages.ups.UPS Priority Overnight',
        description: 'Display method UPS UPS Priority Overnight',
        defaultMessage: 'UPS Next Day'
    },
    'UPS Mail Innovations': {
        id: 'shipping.shippingMessages.ups.UPS Mail Innovations',
        description: 'Display method UPS Mail Innovations',
        defaultMessage: 'UPS Mail Innovations With Tracking'
    },
    '2daySigR': {
        id: 'shipping.shippingMessages.ups.2daySigR',
        description: 'Display method UPS 2daySigR',
        defaultMessage: 'UPS 2 Day Signature Required'
    },
    Ground: {
        id: 'shipping.shippingMessages.ups.Ground',
        description: 'Display method UPS Ground',
        defaultMessage: 'UPS Ground'
    },
    upsground: {
        id: 'shipping.shippingMessages.ups.upsground',
        description: 'Display method upsground',
        defaultMessage: 'UPS Ground'
    },
    'UPS Saturday': {
        id: 'shipping.shippingMessages.ups.UPS Saturday',
        description: 'Display method UPS Saturday',
        defaultMessage: 'UPS Saturday'
    }
});

export const shippingMethodDisplayNames = fromJS({
    FEDEX_FIXED: methodDisplayFedexFixed,
    FEDEX: methodDisplayFedex,
    DHL: methodDisplayDHL,
    USPS: methodDisplayUSPS,
    UPS: methodDisplayUPS,
    UKPOSTOFFICE: methodDisplayUKPostOffice,
    CANADAPOST: methodDisplayCanadianPost,
    ROYAL_MAIL: methodDisplayRoyalMail
});

export const maybeGetDisplayName = (carrier, methodName) => (
    shippingMethodDisplayNames.getIn([
        carrier,
        methodName
    ], null) 
);

export default shippingMessages;
